import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from "react";

import { ICONS } from "../utils/assets";
import "../styles/footer.css";

export const Footer = () => {
  const { instance } = useMsal();
  const [customerInfo, setCustomerInfo] = useState(
    JSON.parse(sessionStorage.getItem("LS_CUSTOMER_INFO"))
  );
  let activeAccount;

  if (instance) {
    activeAccount = instance.getActiveAccount();
  }
  const handleLogoutRedirect = () => {
    sessionStorage.clear();
    instance.logoutRedirect();
  };

  useEffect(() => {
    const userInfo = sessionStorage.getItem("LS_CUSTOMER_INFO");

    if (userInfo) {
      setCustomerInfo(JSON.parse(userInfo));
    }
  }, []);

  return (
    <footer className="welcome-footer">
      <div className="welcome-footer__signout">
        <button className="button button--icon" onClick={handleLogoutRedirect}>
          <img src={ICONS.SIGNOUT_ICON} alt="Sign out" />
        </button>
        <div className="footer-signout-displayname">
          <p className="user-account">
            {activeAccount && activeAccount.name !== "unknown"
              ? activeAccount.name
              : customerInfo.displayName || "Unknown"}{" "}
          </p>
          <p className="user-email">
            {activeAccount ? activeAccount?.username : null}
          </p>
        </div>
      </div>
      <div className="welcome-footer__contact">
        <p className="paragraph-md">Need help? Contact our Customer Support</p>
        <div className="welcome-footer__copyright">
          <p className="paragraph-md">&copy; Quickmove 2024</p>
          <a href="#" className="paragraph-md semibold paragraph-md--dark">
            Terms & Conditions
          </a>
        </div>
      </div>
    </footer>
  );
};
